module.exports = __webpack_public_path__ + "img/splashLogo.e4d85e5b.png";